<div class="p-3 bg-white" [formGroup]="udcForm" style="min-width: 480px; font-size: 0.88rem;">
  <div class="border-bottom pb-2 mb-3">
    <h3 class="h5 m-0 fw-bold text-dark">➕ Crear Nueva Clave Catálogo (UDC)</h3>
    <span class="small text-muted font-monospace">Global System Catalog Provisioning</span>
  </div>

  <div class="row g-2 mb-3">
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control text-uppercase font-monospace fw-bold" id="addSys" formControlName="udcSystem" placeholder="AUTOS"
               [ngClass]="{'is-invalid': udcForm.get('udcSystem')?.touched && udcForm.get('udcSystem')?.invalid}">
        <label for="addSys">Código Sistema (SYSTEM) *</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control text-uppercase font-monospace fw-bold" id="addKey" formControlName="udcKey" placeholder="MARCAS"
               [ngClass]="{'is-invalid': udcForm.get('udcKey')?.touched && udcForm.get('udcKey')?.invalid}">
        <label for="addKey">Categoría Clave (KEY) *</label>
      </div>
    </div>
  </div>

  <div class="form-floating mb-3">
    <input type="text" class="form-control text-uppercase fw-semibold" id="addDesc" formControlName="description" placeholder="Desc"
           [ngClass]="{'is-invalid': udcForm.get('description')?.touched && udcForm.get('description')?.invalid}">
    <label for="addDesc">Descripción Larga del Catálogo *</label>
  </div>

  <div class="row g-2 mb-3">
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control text-uppercase font-monospace" id="addV1" formControlName="strValue1" placeholder="V1">
        <label for="addV1">Valor Alfanumérico 1 (Opcional)</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control text-uppercase font-monospace" id="addV2" formControlName="strValue2" placeholder="V2">
        <label for="addV2">Valor Alfanumérico 2 (Opcional)</label>
      </div>
    </div>
  </div>

  <div class="form-check form-switch mb-3 ps-5">
    <input class="form-check-input" type="checkbox" id="addBool" formControlName="booleanValue">
    <label class="form-check-label fw-bold text-secondary" for="addBool">Clave de Catálogo Habilitada de forma inmediata</label>
  </div>

  <div class="d-flex justify-content-end gap-2 border-top pt-2">
    <button type="button" class="btn btn-sm btn-light border" (click)="dialogRef.close()">Cancelar</button>
    <button type="button" class="btn btn-sm btn-success text-white px-4 fw-bold shadow-sm" (click)="onSubmit()">🚀 Inyectar Catálogo</button>
  </div>
</div>